import { Helmet } from 'react-helmet-async';
import { styled } from '@mui/material/styles';
import { Typography, Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { BlankCard } from 'src/components/cards/blankCard';
import UsersListSvg from 'src/assets/svgs/usersList';
import { ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { ConsoleAuthListSection } from '../sections/consoleAuth/consoleAuthList';
import pageTitle from '../utils/pageTitles.json';

const MainSection = styled('div')(() => ({
  padding: '64px 20px 0px 88px',
  backgroundColor: 'rgb(240, 240, 240)',
  height: '100vh',
  overflow: 'hidden',
}));

const HeadingSection = styled('div')(() => ({
  width: '100%',
  padding: '20px 0px 20px 0px',
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
}));

const HeadingContentSection = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '15px',
  alignItems: 'center',
  justifyContent: 'center',
}));

const DetailsListSection = styled('div')(() => ({
  width: '100%',
  height: 'calc(100vh - 155px)',
  overflow: 'hidden',
  overflowY: 'scroll',
}));

export default function ConsoleAuthList() {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{pageTitle?.consoleAuth}</title>
      </Helmet>

      <MainSection>
        <HeadingSection>
          <HeadingContentSection>
            <Box sx={{ mt: '-10px' }}>
              <UsersListSvg />
            </Box>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Console Auth
            </Typography>
          </HeadingContentSection>

          <Button
            startIcon={<AddIcon />}
            sx={{
              backgroundColor: 'rgb(33, 43, 54)',
              color: 'grey.100',
              p: '0px 20px',
              '&:hover': { backgroundColor: 'rgb(69, 79, 91)' },
            }}
            onClick={() => navigate('/createConsoleAuth')}
          >
            Create
          </Button>
        </HeadingSection>

        <BlankCard sx={{ height: '100%', width: '100%', padding: '0px', overflow: 'hidden' }}>
          <DetailsListSection>
            <ConsoleAuthListSection />
          </DetailsListSection>
        </BlankCard>
      </MainSection>
      <ToastContainer />
    </>
  );
}
